export const SLIDER_PRESENTATIONS = Object.freeze({
  MINIMAL: 'minimal',
  FILLED_LANE: 'filled-lane',
});

export const DEFAULT_SLIDER_PRESENTATION = SLIDER_PRESENTATIONS.MINIMAL;
export const SLIDER_PRESENTATION_ATTRIBUTE = 'data-slider-presentation';

export function normalizeSliderPresentation(value) {
  return value === SLIDER_PRESENTATIONS.FILLED_LANE
    ? SLIDER_PRESENTATIONS.FILLED_LANE
    : DEFAULT_SLIDER_PRESENTATION;
}
